import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    scholar: []
}

const scholarSlice = createSlice({
    name: "scholar",
    initialState,
    reducers: {
        setScholar: (state, action) => {
            state.scholar = action.payload;
        }
    }
});

export const { setScholar } = scholarSlice.actions;
export default scholarSlice.reducer;